import { formatNumber } from 'core/service/lib/number-format'

const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

const PolicyValueRowRPUETI = ({
  age,
  yearEndPolicy,
  cumulativeBasicPremium,
  annualBasicPremium,
  surrenderCash,
  annualRiderPremium,
  annualTotalPremium,
  deathBenefit,
  children,
  RPUSumAssured,
  RPUCashpaid,
  ETIYear,
  ETIDay,
  ETIMaturity,
  ETICashpaid,
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{dashedOutOrWithPrecision(annualBasicPremium, 2)}</td>
      <td className="policy-value-annual-rider-premium">{dashedOutOrWithPrecision(annualRiderPremium, 2)}</td>
      <td className="policy-value-annual-total-premium">{dashedOutOrWithPrecision(annualTotalPremium, 2)}</td>
      {children}
      <td className="policy-value-cumulative-basic-premium">{dashedOutOrWithPrecision(cumulativeBasicPremium, 2)}</td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 0)}</td>
      <td className="policy-value-death-benefit">{dashedOutOrWithPrecision(deathBenefit, 2)}</td>
      <td className="policy-value-RPU-cashpaid">{dashedOutOrWithPrecision(RPUCashpaid, 2)}</td>
      <td className="policy-value-RPU-sumAssured">{dashedOutOrWithPrecision(RPUSumAssured, 2)}</td>

      <td className="policy-value-ETI-year">{dashedOutOrWithPrecision(ETIYear, 0)}</td>
      <td className="policy-value-ETI-day">{dashedOutOrWithPrecision(ETIDay, 0)}</td>
      <td className="policy-value-ETI-maturity">{dashedOutOrWithPrecision(ETIMaturity, 2)}</td>
      <td className="policy-value-ETI-cashpaid">{dashedOutOrWithPrecision(ETICashpaid, 2)}</td>
    </tr>
  )
}

export default PolicyValueRowRPUETI
